import { ReadCloudPresetConfig } from '@readcloud/ui/tailwind.config';
import tailwindCSSAnimate from 'tailwindcss-animate';
import tailwindCSSMotion from 'tailwindcss-motion';
import type { Config } from 'tailwindcss';

const config: Config = {
  content: [
    '{apps,libs}/**/*.{ts,tsx,svg}',
    './node_modules/@readcloud/ui/lib/**/*.{js,ts,jsx,tsx,mdx}',
  ],
  corePlugins: {
    preflight: true,
  },
  presets: [ReadCloudPresetConfig],
  prefix: 'rc-',
  theme: {
    extend: {
      colors: {
        brand: {
          DEFAULT: 'hsl(var(--primary))',
          primary: 'hsl(var(--brand-primary))',
          secondary: 'hsl(var(--brand-secondary))',
        },
      },
      keyframes: {
        dash: {
          '0%': { strokeDashoffset: '1000' },
          '100%': { strokeDashoffset: '0' },
        },
      },
      animation: {
        dash: 'dash 10s linear infinite',
      },
      backgroundImage: {
        'brand-gradient':
          'linear-gradient(to bottom, hsl(var(--brand-gradient-start)), hsl(var(--brand-gradient-end)))',
      },
    },
  },
  plugins: [tailwindCSSAnimate, tailwindCSSMotion],
};

export default config;
